window.slideSearch = function (pageId) {
	jQuery("#search2-" + pageId).toggle("slide", { direction: "right" }, 500);
};

window.hideSearch = function (pageId) {
	jQuery("#search2-" + pageId).hide("slide", { direction: "right" }, 500);
};

window.showSearch2 = function (pageId, url) {
	gpssat.App._functions[gpssat.AppPage._tabsActionId]["refresh"] = function () {
		sendSearch2(pageId, url);
	};
	setDataPikerDateSearch2(pageId);
	const searchDiv = jQuery(`#search2-${pageId}`);
	if (searchDiv.css("display") === "none") {
		searchDiv.show("slide", { direction: "right" }, 500);
	}
};

window.setDataPikerDateSearch2 = function (pageId) {
	let date = new Date();
	let datei = new Date();

	if (typeof jQuery("#date_start-" + pageId).attr("interval") !== "undefined" && jQuery("#date_start-" + pageId).attr("interval").length > 0) {
		datei.setDate(datei.getDate() - jQuery("#date_start-" + pageId).attr("interval"));
		datei.setHours("00", "00", "00", "00");
	} else {
		datei.setDate(datei.getDate() - 7);
		datei.setHours("00", "00", "00", "00");
	}

	if (typeof jQuery("#date_start-" + pageId).attr("id") !== "undefined") {
		let format = "DD/MM/YYYY";
		if (jQuery("#date_start-" + pageId).attr("dateTime").length > 0) {
			format += " HH:mm:ss";
		} else if (typeof jQuery("#date_start-" + pageId).attr("format") !== "undefined" && jQuery("#date_start-" + pageId).attr("format").length > 0) {
			format = jQuery("#date_start-" + pageId).attr("format");
		}

		jQuery("#date_start-" + pageId).datetimepicker({
			format: format,
			locale: "pt-BR",
			defaultDate: datei,
			maxDate: date,
		});
	}
	if (typeof jQuery("#date_end-" + pageId).attr("id") !== "undefined") {
		let format = "DD/MM/YYYY";
		if (jQuery("#date_end-" + pageId).attr("dateTime").length > 0) {
			format += " HH:mm:ss";
		} else if (typeof jQuery("#date_start-" + pageId).attr("format") !== "undefined" && jQuery("#date_end-" + pageId).attr("format").length > 0) {
			format = jQuery("#date_end-" + pageId).attr("format");
		}

		if (format === "MM/YYYY") {
			datei = new Date(datei.getFullYear(), datei.getMonth(), 1);
		}

		const limitToday = jQuery("#date_end-" + pageId).attr("limitEndToday") == 1;

		let options = {
			format: format,
			locale: "pt-BR",
			defaultDate: date.setHours("23", "59", "59", "59"),
			minDate: datei,
		};

		if (limitToday) {
			options.maxDate = date;
		}

		jQuery("#date_end-" + pageId).datetimepicker(options);
	}

	if (typeof jQuery("#date_start-" + pageId).attr("id") !== "undefined") {
		jQuery("#date_start-" + pageId).on("dp.change", function (e) {
			let dateEnd = jQuery("#date_end-" + pageId).data("DateTimePicker");

			dateEnd.minDate(e.date);

			let maxDay = parseInt(jQuery("#date_end-" + pageId).attr("maxDay"));

			if (maxDay > 0) {
				let maxDate = moment(e.date).add(maxDay, "days").subtract(1, "milliseconds");
				if (maxDate.isBefore(moment().endOf("day"))) {
					dateEnd.maxDate(maxDate);
				} else {
					dateEnd.maxDate(moment().endOf("day"));
				}
			}

			if (e.date.isAfter(dateEnd.viewDate()) || e.date.isSame(dateEnd.viewDate())) {
				dateEnd.date(e.date.add(1, "days").subtract(1, "milliseconds"));
			}
		});
	}

	jQuery("#hour_start-" + pageId).datetimepicker({
		format: "HH:mm:ss",
		locale: "pt-BR",
		defaultDate: new Date().setHours(0, 0, 0),
	});
	jQuery("#hour_end-" + pageId).datetimepicker({
		format: "HH:mm:ss",
		locale: "pt-BR",
		defaultDate: new Date().setHours(23, 59, 59),
	});
};

jQuery(document).mousedown(function (e) {
	let container = jQuery(".search2-agrofleet");
	// if the target of the click isn't the container nor a descendant of the container

	if (jQuery(e.target).parents(".daterangepicker").length > 0) {
		return;
	}

	if (!container.is(e.target) && container.has(e.target).length === 0) {
		container.hide("slide", { direction: "right" }, 500);
	}
});

window.sendSearch2 = function (pageId, url, onclick) {
	let selected = [];
	var alerts = gpssat.AppMessage;
	//Load Values of the search
	var search_values = jQuery("#treeview2-" + pageId).jstree("get_selected");

	if (typeof onclick === "undefined" && search_values.length < 1) {
		return;
	}

	let data_field = null;
	if (search_values.length > 0) {
		data_field = search_values.join(",");
	}

	var searchOb = {
		_token: jQuery("[name='csrf-token']").attr("content"),
		data_field,
		tree_view_type: jQuery("#treeview2-" + pageId).attr("type"),
	};

	searchOb.pageId = pageId;

	// if (typeof jQuery("[data-content-search='tabs-pages-"+ pageId +"']") !== 'undefined') {
	//     $("[data-content-search='tabs-pages-"+ pageId +"'] input[name='view[]']:checked").each(function() {
	//         selected.push($(this).attr('value'));
	//     });

	//     searchOb.selected = selected;
	// }

	if (typeof jQuery("#date_start-" + pageId).attr("id") !== "undefined") {
		searchOb.date_start = jQuery("#date_start-" + pageId).val();
	}

	if (typeof jQuery("#date_end-" + pageId).attr("id") !== "undefined") {
		searchOb.date_end = jQuery("#date_end-" + pageId).val();
	}

	if (typeof jQuery("#date_range-" + pageId).attr("id") !== "undefined") {
		searchOb.date_range = jQuery("#date_range-" + pageId).val();
	}

	if (typeof jQuery("#hour_start-" + pageId).attr("id") !== "undefined") {
		searchOb.hour_start = jQuery("#hour_start-" + pageId).val();
	}

	if (typeof jQuery("#hour_end-" + pageId).attr("id") !== "undefined") {
		searchOb.hour_end = jQuery("#hour_end-" + pageId).val();
	}

	if (typeof jQuery("#range-fix-" + pageId).attr("id") !== "undefined") {
		searchOb.date_fix = jQuery("#range-fix-" + pageId).val();
	}
	if (typeof jQuery("#s2id_status-" + pageId).attr("id") !== "undefined") {
		searchOb.status = jQuery("#s2id_status-" + pageId).select2("val");
	}
	if (
		typeof jQuery("#search2-" + pageId)
			.find("#sort")
			.attr("id") !== "undefined"
	) {
		searchOb.sort = jQuery("#search2-" + pageId)
			.find("#sort")
			.val();
	}
	if (typeof jQuery("#custom-fields-search2-" + pageId).attr("id") !== "undefined") {
		jQuery("#custom-fields-search2-" + pageId + " select").each(function () {
			if (jQuery(this).attr("id") !== "s2id_status-" + pageId) {
				searchOb[jQuery(this).attr("name")] = jQuery(this).val();
			}
		});
		jQuery("#custom-fields-search2-" + pageId + " input").each(function () {
			const input = jQuery(this);

			if (input.attr("type") == "checkbox") {
				if (!Array.isArray(searchOb[input.attr("name")])) {
					searchOb[input.attr("name")] = [];
				}

				if (input.is(":checked")) {
					searchOb[input.attr("name")].push(input.attr("value"));
				}
			} else {
				searchOb[input.attr("name")] = input.val();
			}
		});
	}
	// if (typeof jQuery("[data-content-search='tabs-pages-"+ pageId +"']") !== 'undefined') {
	//     $("[data-content-search='tabs-pages-"+ pageId +"'] input[name='view[]']:checked").each(function() {
	//         selected.push($(this).attr('value'));
	//     });

	//     searchOb.selected = selected;
	// }

	if (typeof jQuery("[data-content-search='tabs-pages-" + pageId + "']") !== "undefined") {
		// jQuery("[data-content-search='tabs-pages-"+ pageId +"'] input[name='view[]']:checked").each(function () {
		//     if (jQuery(this).attr('id') !== 's2id_status-' + pageId) {
		//         searchOb[jQuery(this).attr('name')] = jQuery(this).val();
		//     }
		// });
		jQuery("[data-content-search='tabs-pages-" + pageId + "'] input[name='view[]']:checked").each(function () {
			const input = jQuery(this);

			if (input.attr("type") == "checkbox") {
				if (!Array.isArray(searchOb[input.attr("name")])) {
					searchOb[input.attr("name")] = [];
				}

				if (input.is(":checked")) {
					searchOb[input.attr("name")].push(input.attr("value"));
				}
			} else {
				searchOb[input.attr("name")] = input.val();
			}
		});
	}

	search2HoverLoader(pageId);
	hideSearch(pageId);
	var start = gpssat.AppResponse._microtime(true);
	var ajax = jQuery.ajax({
		method: "POST",
		url: url,
		data: searchOb,
	});
	ajax.done(function (data) {
		if (data.time) {
			gpssat.AppResponse._timeServer = data.time;
			gpssat.AppResponse._timeInternet = gpssat.AppResponse._microtime(true) - start - data.time;
			data = data.data;
		}

		if (!data || data.length == 0) {
			jQuery("#loading").effect("blind", {}, 300, function () {});
			alerts._warning("Nenhum registro encontrado!");
			if (gpssat.AppTable._tables[pageId] !== undefined) {
				gpssat.AppTable._tables[pageId].clear().draw();
			}
			return;
		} else {
			hideSearch(pageId);
		}

		if (typeof jQuery("#populate-table-" + pageId).attr("id") !== "undefined") {
			jQuery("#populate-table-" + pageId).html(data.html);
		}

		if (typeof gpssat.AppTable._tables[pageId] !== "undefined") {
			gpssat.AppTable._tables[pageId].clear().draw();
			gpssat.AppTable._tables[pageId].rows.add(data).draw();
		}

		if (typeof gpssat.App._functions[pageId]["calbackSearch" + pageId] == "function") {
			gpssat.App._functions[pageId]["calbackSearch" + pageId](data);
		}

		gpssat.AppResponse._timeBrowser = gpssat.AppResponse._microtime(true) - start;
		gpssat.AppResponse._generatePopover();
	});

	ajax.fail(function (val) {
		if (val.responseText.indexOf("{") > -1) {
			var msg = "<ul>";
			for (var i in val.responseJSON) {
				msg += "<li>" + val.responseJSON[i] + "</li>";
			}
			msg += "</ul>";
		} else {
			msg = val.responseText;
		}

		if (val.status === 422) {
			alerts._info(msg, "");
		} else {
			alerts._error(msg);
		}
	});

	ajax.always(function () {
		serach2RemoveLoader(pageId);
	});
};

window.search2HoverLoader = function (pageId) {
	var container = jQuery('[data-content="tabs-pages-' + pageId + '"]');
	var container2 = jQuery("[data-content='tabs-pages-" + pageId + "']").find(".footer");
	var spinner =
		"<i class='fa fa-spinner fa-2x fa-spin' style='--local-icon-font-size: 32px; position: absolute; top: calc(50% - var(--local-icon-font-size)); left: calc(50% - var(--local-icon-font-size)); color:ghostwhite;'></i>";
	container.append("<div class='loader-div-" + pageId + "' style='z-index: 1300'>" + spinner + "</div>");
	container2.append("<div class='loader-div-" + pageId + "'></div>");

	jQuery(".loader-div-" + pageId).each(function () {
		jQuery(this).addClass("loader-div");
		jQuery(this).css("background-color", "rgba(0,0,0,0.5)");
	});
};

window.serach2RemoveLoader = function (pageId) {
	jQuery(".loader-div-" + pageId).each(function () {
		jQuery(this).remove();
	});
};
